import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { PersonalOfficeService } from '../services/personal-office.service';
import { take } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { TeamEntity } from '../../store/entities/TeamEntity';

@Injectable({
	providedIn: 'root',
})
export class PoTeamsResolver implements Resolve<TeamEntity[]> {
	constructor(private po: PersonalOfficeService) {}

	resolve(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<TeamEntity[]> | Promise<TeamEntity[]> | TeamEntity[] {
		return this.po.getTeams(state.url.includes('teamkonfiguration')).pipe(take(1));
	}
}
